import { takeLatest, call, put } from 'redux-saga/effects';
import { AssetDetailsApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { getPhysicalConnectionsAction } from './actions';
import * as actionTypes from './constants';

export function* getPhysicalConnectionsSaga({ assetId }) {
    yield put(getPhysicalConnectionsAction(apiCallStatus.LOADING));
    try {
        const response = yield call(AssetDetailsApi.getPhysicalConnectionsByAsset, assetId);
        yield put(getPhysicalConnectionsAction(apiCallStatus.SUCCESS, response));
    } catch (err) {
        yield put(getPhysicalConnectionsAction(apiCallStatus.ERROR, null, err));
    }
}

export function* assetPhysicalConnectionWatchers() {
    yield takeLatest(actionTypes.GET_PHYSICAL_CONNECTIONS_REQUEST, getPhysicalConnectionsSaga);
}
